import React from "react";
import { ArrowRight } from "lucide-react";

/**
 * Reusable inline CTA — branded banner that scrolls to contact section.
 * Optionally accepts an `advisorName` which (when present) pre-selects
 * the advisor in the contact form by dispatching a custom event.
 */
const ScheduleCTA = ({
  label = "Agendar asesoría",
  eyebrow,
  advisorName,
  testId = "schedule-cta",
  variant = "default",
}) => {
  const go = () => {
    if (advisorName) {
      // Persist advisor selection so Contact form can pick it up
      try {
        sessionStorage.setItem("emb:selectedAdvisor", advisorName);
      } catch (_) {}
      window.dispatchEvent(
        new CustomEvent("emb:select-advisor", { detail: { advisorName } })
      );
    }
    const el = document.getElementById("contacto");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  if (variant === "compact") {
    return (
      <button
        data-testid={testId}
        onClick={go}
        className="group inline-flex items-center gap-2 bg-[#3D1565] hover:bg-[#4a1c79] text-white text-sm tracking-wider uppercase px-7 py-3.5 rounded-sm transition-all duration-300 hover:-translate-y-0.5"
      >
        <span>{label}</span>
        <ArrowRight
          size={15}
          className="transition-transform duration-300 group-hover:translate-x-1"
        />
      </button>
    );
  }

  return (
    <div
      data-testid={`${testId}-banner`}
      className="relative overflow-hidden rounded-sm border border-[#3D1565]/40 bg-gradient-to-r from-[#150A1F] via-[#1A0E2A] to-[#0B0410] px-6 sm:px-10 py-8 sm:py-10"
    >
      {/* Decorative hex */}
      <div
        className="absolute -right-12 -top-12 w-44 h-44 opacity-15 pointer-events-none"
        aria-hidden="true"
      >
        <svg viewBox="0 0 100 115" className="w-full h-full">
          <path
            d="M50 0 L100 29 L100 86 L50 115 L0 86 L0 29 Z"
            fill="none"
            stroke="#E6D5B8"
            strokeWidth="1"
          />
        </svg>
      </div>

      <div className="relative flex flex-col sm:flex-row sm:items-center justify-between gap-6">
        <div>
          {eyebrow && (
            <div className="text-[10px] tracking-luxury uppercase text-[#E6D5B8] mb-2">
              {eyebrow}
            </div>
          )}
          <h3 className="font-display text-2xl lg:text-3xl text-[#F9F6F0] font-light leading-tight">
            ¿Listo para dar el siguiente paso?
          </h3>
          <p className="text-sm text-[#F9F6F0]/65 mt-2 max-w-xl font-light">
            Reserva una asesoría sin costo y sin compromiso — un especialista
            EMB te orientará sobre los productos ideales para tu etapa.
          </p>
        </div>
        <button
          data-testid={testId}
          onClick={go}
          className="group shrink-0 inline-flex items-center gap-2 bg-[#3D1565] hover:bg-[#4a1c79] text-white text-sm tracking-wider uppercase px-7 py-4 rounded-sm transition-all duration-300 hover:-translate-y-0.5 shadow-[0_4px_24px_-4px_rgba(61,21,101,0.5)]"
        >
          <span>{label}</span>
          <ArrowRight
            size={16}
            className="transition-transform duration-300 group-hover:translate-x-1"
          />
        </button>
      </div>
    </div>
  );
};

export default ScheduleCTA;
